import { useRef } from "react"

export const useGetter = <T>(value?: T) => {
    const valueRef = useRef(value)
    const getValueRef = useRef(() => valueRef.current)
    return [getValueRef.current, (value: T) => valueRef.current = value] as const
}